import { ANALYTICS_EVENTS, ANALYTICS_PROPERTY_KEYS, COMPONENT_OUTCOMES, DCM_PAGES } from '../constants';
import { trackAnalyticsEvent } from '../core/analyticsClient';

export type TrackInventoryCheckPerformedParams = {
  lineItemId?: string;
  lineItemRevision?: string;
  campaignId?: string;
  adAccountId?: string;
  componentOutcome: (typeof COMPONENT_OUTCOMES)[keyof typeof COMPONENT_OUTCOMES];
  availableInventoryPercentage?: number;
  hasInventorySuggestions?: boolean;
  durationMs?: number;
  isValidatedEdit?: boolean;
  unavailableReason?: string;
};

export const trackInventoryCheckPerformed = ({
  lineItemId,
  lineItemRevision,
  campaignId,
  adAccountId,
  componentOutcome,
  availableInventoryPercentage,
  hasInventorySuggestions,
  durationMs,
  isValidatedEdit,
  unavailableReason,
}: TrackInventoryCheckPerformedParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.INVENTORY_CHECK_PERFORMED, {
    [ANALYTICS_PROPERTY_KEYS.LINE_ITEM_ID]: lineItemId,
    [ANALYTICS_PROPERTY_KEYS.REVISION_NUMBER]: lineItemRevision,
    [ANALYTICS_PROPERTY_KEYS.CAMPAIGN_ID]: campaignId,
    [ANALYTICS_PROPERTY_KEYS.AD_ACCOUNT_ID]: adAccountId,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: componentOutcome,
    [ANALYTICS_PROPERTY_KEYS.INVENTORY_PERCENTAGE]: availableInventoryPercentage,
    [ANALYTICS_PROPERTY_KEYS.HAS_INVENTORY_SUGGESTIONS]: hasInventorySuggestions,
    [ANALYTICS_PROPERTY_KEYS.DURATION_MS]: durationMs,
    [ANALYTICS_PROPERTY_KEYS.IS_VALIDATED_EDIT]: isValidatedEdit,
    [ANALYTICS_PROPERTY_KEYS.UNAVAILABLE_REASON]: unavailableReason,
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.CAMPAIGN_BUILDER,
  });
};
